import React, { useState } from 'react';
import './AI_tools_part_two.css'; // Your existing styles
import AI_tools from '../AI_tools/AI_tools';


const AI_tools_part_two = ({ title, description, reason, link, isFree }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="toolcard_container">
  <div className="toolcard_content">
    <h2 className="toolcard_title">{title}</h2>
    <p className="toolcard_text">{description}</p>
    <p className="toolcard_text">{reason}</p>
   
  </div>
   <p className="toolcard_text"><strong>Free/Paid:</strong> {isFree}</p>
  <a
    className="toolcard_link"
    href={link}
    target="_blank"
    rel="noopener noreferrer"
  >
    🔗 Visit {title}
  </a>
</div>

    </>
  );
};

export default AI_tools_part_two;
